import {
  STAFF_REGULATOR_STATUSES,
  type StaffRegulator,
  type StaffRegulatorStatus,
} from "./types";

const readStatus = (value: unknown): StaffRegulatorStatus | null =>
  STAFF_REGULATOR_STATUSES.includes(value as StaffRegulatorStatus)
    ? (value as StaffRegulatorStatus)
    : null;

const readString = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value : null;

const readIps = (value: unknown): string[] =>
  Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : [];

export const parseStaffRegulator = (
  payload: unknown,
): StaffRegulator | null => {
  if (!payload || typeof payload !== "object") return null;
  const row = payload as Record<string, unknown>;
  const adminId = readString(row.admin_id);
  const email = readString(row.email);
  const status = readStatus(row.status);
  if (!adminId || !email || !status) return null;
  return {
    admin_id: adminId,
    email,
    status,
    given_name: readString(row.given_name),
    family_name: readString(row.family_name),
    timezone: readString(row.timezone),
    whitelisted_ips: readIps(row.whitelisted_ips),
  };
};

export const parseStaffRegulatorList = (payload: unknown): StaffRegulator[] => {
  if (Array.isArray(payload)) {
    return payload
      .map(parseStaffRegulator)
      .filter((item): item is StaffRegulator => item !== null);
  }
  if (
    payload &&
    typeof payload === "object" &&
    Array.isArray((payload as { items?: unknown }).items)
  ) {
    return parseStaffRegulatorList((payload as { items: unknown[] }).items);
  }
  return [];
};
